// FileUpload.jsx
import React from 'react';

export default function FileReUpload({ file, onFileChange, onRemove, errorText, required, firstReceipt = false }) {
  return (
    <>
        <div style={{marginBottom: 20}}>
          {/* <label style={{ marginTop: 20 }} className="form-input-label-expense">
            Receipt*
          </label> */}
          <div className="file-upload-container" style={ firstReceipt ? { "minHeight": '150px' } : {} }>
            <input
              type="file"
              id="file-upload"
              className="file-input-hidden"
              onChange={(e) => onFileChange(e.target.files[0] || null)}
              required={required}
            />
            <label htmlFor="file-upload" className="file-label">
              {!firstReceipt ? 'Upload another receipt' : 'Upload or drop a receipt to get started'}
            </label>
          </div>
          {errorText ? <div className="error-text">{errorText}</div> : null}
        </div>
    </>
  );
}
